import React, { Fragment, useRef, useEffect, useState, useMemo } from 'react'
import LiveVideo from 'components/LiveVideo'
import Content from 'components/Content'
import { useSelector, useDispatch } from 'react-redux'
import { getEvent } from 'actions/event'
import { getItems } from 'actions/items'
import { useParams } from 'react-router-dom'
import PubnubController from 'components/PubnubController'
import { updateItem, closeLiveItem } from 'actions/items'
import { setViewers } from 'actions/viewers'
import { openSnackBar } from 'actions/snack-bar'
import { updateEventStreams, updateEventData } from 'actions/event'
import { setVideoDisplay } from 'actions/stream'
import serialize from 'store/serialize'
import { isEmpty } from 'lodash'
import { Box, useMediaQuery } from '@material-ui/core'
import useStyles from './styles'
import { getEventStats } from 'actions/event'
import classnames from 'clsx'
import Sponsors from 'components/Sponsors'
import { pushBid } from 'actions/items'
import { pushDonation } from 'actions/event'
import { removeDonation } from 'actions/event'
import { removeBid } from 'actions/items'
import { clearBids } from 'actions/items'
import { clearPurchases } from 'actions/items'
import { pushPurchase } from 'actions/items'
import { setBidId } from 'actions/items'
import { setPurchaseId } from 'actions/items'
import EngagementButtons from 'components/EngagementButtons'
import { useFullScreen } from 'react-browser-hooks'
import { changeFullscreen } from 'actions/window'
import {
  setVideoControlled,
  setAudioSetting,
  getServerTime
} from 'actions/stream'
import { setDonationId } from 'actions/event'
import { pushEventChats } from 'actions/event'
import { setPurchases } from 'actions/items'
import { getMessages } from 'actions/event'
import { getEventTickets, getUserTickets } from 'actions/event'
import previousHook from 'utils/previousHook'
import { pushItems } from 'actions/items'
import { removeMessageLocal } from 'actions/event'
import { updateApprovedUser } from 'actions/authentication'
import { setServerTime } from 'actions/stream'
const uuid = Math.random()
  .toString()
  .substring(3, 10)

const Index = () => {
  const classes = useStyles()
  const pubnub = useRef(null)
  const pubnub2 = useRef(null)
  const pubnub3 = useRef(null)
  const videoBoxRef = useRef(null)
  const dispatch = useDispatch()
  const orientation = useSelector(state => state.window.orientation)
  const windowFullscreen = useSelector(state => state.window.fullscreen)
  const isSmallerThanIpadLandscape = useMediaQuery('(max-width: 1023px)')
  const isMobile = useMediaQuery('(max-width: 767px)')
  const event = useSelector(state => state.event.event)
  const myTicketsLoading = useSelector(state => state.event.myTicketsLoading)
  const videoControlled = useSelector(
    state =>
      state.stream.cloudinaryVideoControlled &&
      state.stream.egLiveVideoControlled
  )
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const previousAuthenticatedUser = previousHook(authenticatedUser)
  const purchases = useSelector(state => state.items.purchases)
  const donateMode = Number(event.live_settings.live_mode) === 1
  const liveItem = useSelector(state => state.items.liveItem)
  const items = useSelector(state => state.items.items)
  const currentItem = useSelector(state => {
    const item = state.items.items.find(i => i.is_live)
    if (item && !donateMode) {
      return item
    } else {
      return null
    }
  })
  const { eventId } = useParams()
  const [itemDetailsOpen, setItemDetailsOpen] = useState(false)
  const [eventDetailsOpen, setEventDetailsOpen] = useState(true)
  const [welcomeDialogOpen, setWelcomeDialogOpen] = useState(true)
  const [loadedUserTickets, setLoadedUserTickets] = useState(false)
  const { fullScreen } = useFullScreen()
  const hasLiveVideo =
    event.live_url_data && event.live_url_data.find(x => x.live_now)
  const liveVideo =
    // videoControlled here is for weird mobile issue
    videoControlled && hasLiveVideo

  const loadVideos = () => {
    const videos = [
      document.getElementById('cloudinaryVideo'),
      document.getElementById('egliveVideo')
    ]
    // https://stackoverflow.com/questions/3258587/how-to-properly-unload-destroy-a-video-element
    videos.map(x => {
      if (x) {
        x.muted = true
        // setTimeout(() => {
        //   x.play()
        //     .then(() => {
        //       x.pause()
        //       x.removeAttribute('src')
        //       x.load()
        //       x.muted = false
        //     })
        //     .catch(console.log)
        // }, 100)
      }
    })
  }
  useEffect(() => {
    if (window.location.pathname.includes('&videomute=1')) {
      if (liveVideo.type === 'zoom') {
        dispatch(setAudioSetting(true))
        document.getElementById('egliveVideo').muted = true

        document.getElementById('cloudinaryVideo').muted = true
      }
    }
  }, [])

  useEffect(() => {
    dispatch(getEvent(eventId))
      .then(res => {
        // dispatch(getEventTickets(eventId))
        // if (!isEmpty(authenticatedUser)) {
        //   dispatch(getUserTickets(authenticatedUser.user_id, eventId))
        // }
        dispatch(getItems(eventId))
        dispatch(getMessages(res.auction_code))
        loadVideos()
      })
      .catch(err => {
        if (err && err.status && err.status === 401) {
          localStorage.clear()
          dispatch({ type: 'RESET_STORE' })
        }
        console.log(err)
        dispatch(openSnackBar({ message: 'Error loading event' }))
        // setTimeout(() => {
        //   window.location.reload()
        // }, 1000)
      })
    dispatch(getEventStats(eventId))
  }, [])

  useEffect(() => {
    if (!isEmpty(authenticatedUser) && authenticatedUser.user_id) {
      // gets logged in users tickets to this event
      // setLoadedUserTickets(true)
      // dispatch(getUserTickets(authenticatedUser.user_id, eventId))
      if (pubnub.current) {
        pubnub.current.setUUID(authenticatedUser.user_id)
        pubnub2.current.setUUID(authenticatedUser.user_id)
        pubnub3.current.setUUID(authenticatedUser.user_id)
      }
    }
  }, [authenticatedUser, pubnub, pubnub2, pubnub3])

  const handleMessage = data => {
    console.log({ emberPubnub: data })
    const action = data.action
    if (action === 'updateItem') {
      const updateData = Object.assign({}, data.data)
      // fix for empty image array
      if (updateData.hasOwnProperty('image') && updateData.image === '[]') {
        updateData.image = [
          {
            original_image_name: 'eg_placeholder_xhn1xm'
          }
        ]
      }
      if (
        updateData.hasOwnProperty('high_bid_data') &&
        updateData.high_bid_data !== null
      ) {
        if (
          !isEmpty(currentItem) &&
          updateData.item_id === currentItem.item_id
        ) {
          if (updateData.high_bid > currentItem.high_bid) {
            // ADDED HIGH BID
            serialize('bid', {
              item_id: updateData.item_id,
              bid_id: updateData.high_bid_data.high_bid_id,
              bid_amt: updateData.high_bid,
              bid_time: updateData.high_bid_data.high_bid_time,
              user_id: updateData.high_bid_data.high_bid_user_id,
              user_name: updateData.high_bid_data.high_bid_user_name,
              user_phone: updateData.high_bid_data.high_bid_user_phone,
              user_email: updateData.high_bid_data.high_bid_user_email,
              anon: updateData.high_bid_data.high_bid_anon
            }).then(response => {
              dispatch(setBidId(response))
              dispatch(pushBid(response))
            })
            serialize('engagement', {
              user_id: updateData.high_bid_data.high_bid_user_id,
              paddle_number: updateData.high_bid_data.high_bid_user_phone.slice(
                updateData.high_bid_data.high_bid_user_phone.length - 4
              ),
              amount: updateData.high_bid,
              name: updateData.high_bid_data.high_bid_user_name,
              timestamp: updateData.high_bid_data.high_bid_time,
              anon: updateData.high_bid_data.high_bid_anon,
              type: 'bid'
            }).then(serializedResponse => {
              dispatch(pushEventChats([serializedResponse]))
            })
          } else if (updateData.high_bid < currentItem.high_bid) {
            // REMOVED HIGH BID
            dispatch(removeBid(updateData.high_bid_data.high_bid_id))
          }
        }
      } else {
        // dispatch(clearBids())
        // dispatch(clearPurchases())
      }
      serialize('item', updateData).then(response => {
        if (updateData.hasOwnProperty('is_live')) {
          if (
            response.hasOwnProperty('status') &&
            response.status === 2 &&
            !response.is_live
          ) {
            if (!isEmpty(liveItem)) {
              dispatch(closeLiveItem())
              // ITEM CLOSED
              serialize('engagement', {
                item_id: liveItem.item_id,
                status: 2,
                type: 'item',
                timestamp: new Date(),
                high_bid_data: liveItem.high_bid_data || {}
              }).then(serializedResponse => {
                dispatch(pushEventChats([serializedResponse]))
              })
              setTimeout(() => {
                dispatch(updateItem(response.item_id, response))
                dispatch(clearBids())
                dispatch(clearPurchases())
              }, 5000)
            } else {
              dispatch(updateItem(response.item_id, response))
            }
          } else {
            dispatch(updateItem(response.item_id, response))
          }
        } else {
          dispatch(updateItem(response.item_id, response))
        }
      })
    } else if (action === 'updateItems') {
      const { item_ids, ...rest } = data.data
      const updateData = Object.assign({}, rest)
      // fix for empty image array
      if (updateData.hasOwnProperty('image') && updateData.image === '[]') {
        updateData.image = [
          {
            original_image_name: 'eg_placeholder_xhn1xm'
          }
        ]
      }
      serialize('item', updateData).then(response => {
        item_ids.forEach(itemId => {
          dispatch(updateItem(parseInt(itemId, 10), response))
        })
      })
      if (updateData.hasOwnProperty('is_live')) {
        if (!updateData.is_live) {
          dispatch(clearBids())
          dispatch(clearPurchases())
        } else {
          // ITEM WENT LIVE
          item_ids.forEach(itemId => {
            serialize('engagement', {
              item_id: parseInt(itemId, 10),
              status: 1,
              type: 'item',
              timestamp: new Date()
            }).then(serializedResponse => {
              dispatch(pushEventChats([serializedResponse]))
            })
          })
        }
      }
    } else if (action === 'updateStreams') {
      console.log('Received updateStreams action:', data.data)
      
      // Check if there's any live stream in the data
      const hasLiveStream = data.data && data.data.some(stream => stream.live_now)
      console.log('Has live stream in update:', hasLiveStream)
      
      // If we have a live stream, make sure both video controls are enabled
      if (hasLiveStream) {
        // Force both video controls to be enabled to ensure playback works
        dispatch(setVideoControlled('cloudinary', true))
        dispatch(setVideoControlled('egLive', true))
        
        // Force video display on
        dispatch(setVideoDisplay(true))
      }
      
      // Update the streams data
      dispatch(updateEventStreams(data.data))
    } else if (action === 'updateEvent') {
      // if event.live_settings.is_live changed to false
      const isRehearsal =
        window.location.pathname.includes('&rehearsal=1') ||
        window.location.pathname.includes('&videomute=1')
      if (
        data.data.hasOwnProperty('live_settings') &&
        data.data.live_settings.hasOwnProperty('is_live') &&
        !data.data.live_settings.is_live &&
        !isRehearsal
      ) {
        dispatch(setVideoControlled('egLive', false))
        dispatch(setVideoControlled('cloudinary', false))
      }
      if (isRehearsal) {
        // is in rehearsal mode
        if (
          data.data.hasOwnProperty('live_settings') &&
          data.data.live_settings.hasOwnProperty('is_live')
        ) {
          // if the event updates have an is_live live setting property, override it with true (to stay in rehearsal mode)
          try {
            // prevents throwing an error just in case something went wrong setting the property
            data.data.live_settings.is_live = true
          } catch (err) {
            console.log(err)
          }
        }
      }
      serialize('event', { ...event, ...data.data }).then(response => {
        dispatch(updateEventData(response))
      })
    } else if (action === 'updateStream') {
      serialize('engagement', data.data).then(serializedResponse => {
        dispatch(pushEventChats(serializedResponse))
      })
    } else if (action === 'createItem') {
      serialize('item', data.data).then(serializedResponse =>
        dispatch(pushItems(serializedResponse))
      )
    } else if (action === 'removeChat') {
      dispatch(removeMessageLocal(parseInt(data.data.chat_id, 10)))
    } else if (action === 'userApprovedEvent') {
      authenticatedUser.user_events.map(x => {
        if (x.eid.toString() === data.data.eid) {
          //console.log(data.data.approved)
          x.approved = parseInt(data.data.approved, 10)
        }
      })
      dispatch(updateApprovedUser(authenticatedUser))
    } else if (action === 'syncStream') {
      try {
        document.getElementById('cloudinaryVideo').currentTime =
          data.data.playhead_offset
      } catch (err) {
        console.log("video element hasn't rendered yet")
      }
    }
  }

  const handleAdminMessage = pubnubData => {
    console.log({ adminPubnub: pubnubData })
    const { action, data } = pubnubData
    const updateData = Object.assign({}, data)
    if (action === 'addDonation') {
      //console.log(data)
      serialize('donation', updateData).then(response => {
        dispatch(setDonationId(response))
        dispatch(pushDonation(response))
        serialize('engagement', {
          user_id: response.user_id,
          paddle_number:
            response.paddle_number ||
            response.user_phone.slice(response.user_phone.length - 4),
          amount: response.donation_amt,
          name: response.user_name,
          timestamp: response.donation_time,
          type: 'donation',
          anon: response.anon
        }).then(serializedResponse => {
          dispatch(pushEventChats([serializedResponse]))
        })
      })
    }
    if (action === 'removeDonation') {
      dispatch(removeDonation(parseInt(data.id, 10)))
    }
    if (action === 'updateItem') {
      if (data.hasOwnProperty('items_purchased')) {
        // handle fixed item sales
        if (
          !isEmpty(currentItem) &&
          updateData.item_id === currentItem.item_id
        ) {
          // updates are for the current live item
          if (
            purchases === null ||
            parseInt(updateData.items_purchased, 10) > purchases.length
          ) {
            // ADDED HIGH BID
            serialize('purchase', {
              item_cost: updateData.purchase_amount,
              qty: 1,
              user_name: updateData.full_name,
              user_phone: updateData.phone,
              user_id: updateData.user_id
            }).then(response => {
              dispatch(setPurchaseId(response))
              dispatch(pushPurchase(response))
              serialize('engagement', {
                user_id: response.user_id,
                paddle_number:
                  updateData.paddle_number ||
                  response.user_phone.slice(response.user_phone.length - 4),
                amount: response.item_cost,
                name: response.user_name,
                timestamp: new Date(),
                type: 'purchase',
                anon: updateData.anon
              }).then(serializedResponse => {
                dispatch(pushEventChats([serializedResponse]))
              })
            })
          } else if (
            parseInt(updateData.items_purchased, 10) < purchases.length
          ) {
            // REMOVED HIGH BID
            // dispatch(removeBid(updateData.high_bid_data.high_bid_id))
          }
        }
      }
    }
  }

  const handlePresence = data => {
    dispatch(setViewers(data.occupancy))
  }

  const handlePlayClicked = () => {
    if (orientation === 'landscape' && isSmallerThanIpadLandscape) {
      videoBoxRef.current.requestFullscreen().catch(err => console.error(err))
    }
  }

  // old condition to show content box
  // const actionsBoxVisible = useMemo(() => {
  //   return event.live_settings.is_live && (!isEmpty(currentItem) || donateMode)
  // }, [currentItem, donateMode, event.live_settings.is_live])

  const handleFullscreen = () => {
    if (document.fullscreenEnabled) {
      if (!document.fullscreenElement) {
        document
          .getElementById('video-box')
          .requestFullscreen()
          .catch(err => console.log(err))
      } else {
        document.exitFullscreen()
      }
    } else {
      window.top.postMessage(
        {
          liveApp: {
            action: windowFullscreen ? 'exitFullScreen' : 'goFullScreen'
          }
        },
        '*'
      )
      dispatch(changeFullscreen(!windowFullscreen))
    }
  }

  return (
    <Box
      className={classnames(classes.page, classes[orientation], {
        [classes.isFullscreen]: fullScreen || windowFullscreen
      })}
    >
      <Box className={classes.container}>
        <Box sx={{
          height: '100%',
          backgroundColor: '#f1f1f1'
        }} className={classes.videoBox} id="video-box" ref={videoBoxRef}>
          <LiveVideo
            itemDetailsOpen={itemDetailsOpen}
            eventDetailsOpen={eventDetailsOpen}
            setEventDetailsOpen={setEventDetailsOpen}
            welcomeDialogOpen={welcomeDialogOpen}
            onPlayButtonClick={handlePlayClicked}
            handleFullscreen={handleFullscreen}
          />
        </Box>
        {event.live_settings.is_live && (
          <Box
            className={classnames(classes.actionsBox, {
              [classes.actionsBoxVisible]: videoControlled
            })}
          >
            <Content
              itemDetailsOpen={itemDetailsOpen}
              setItemDetailsOpen={setItemDetailsOpen}
              eventDetailsOpen={eventDetailsOpen}
              setEventDetailsOpen={setEventDetailsOpen}
            />
          </Box>
        )}
        {event && event.auction_code && (
          <Fragment>
            <PubnubController
              channelName={`ember-event-${event.auction_code}`}
              onMessage={handleMessage}
              ref={pubnub}
              //uuid={uuid}
            />
            <PubnubController
              channelName={`admin-event-${event.auction_code}`}
              onMessage={handleAdminMessage}
              //uuid={uuid}
            />
            <PubnubController
              channelName={`streams-event-${event.auction_code}`}
              onPresence={handlePresence}
              withPresence
              ref={pubnub2}
              //uuid={uuid}
            />
            <PubnubController
              channelName={`ember-user-${authenticatedUser.user_id}`}
              onMessage={handleMessage}
              ref={pubnub3}
              //uuid={uuid}
            />
          </Fragment>
        )}
        <EngagementButtons mobile hideControls={!videoControlled} />
      </Box>
      {event.live_settings.is_live && videoControlled && (
        <Box className={classes.actionsBoxMobile}>
          <Content
            itemDetailsOpen={itemDetailsOpen}
            setItemDetailsOpen={setItemDetailsOpen}
            eventDetailsOpen={eventDetailsOpen}
            setEventDetailsOpen={setEventDetailsOpen}
          />
        </Box>
      )}
    </Box>
  )
}

export default Index



// WEBPACK FOOTER //
// ./src/pages/Live/index.jsx